import Vue from 'vue'
import Router from 'vue-router'
import axios from 'axios'
import store from '@/store'

Vue.use(Router)

let router = new Router({
  mode: 'history',
  // base: process.env.BASE_URL,
  routes: [
    {
      path: "/Login",
      name: "Login",
      component: () => import('@/views/pages/Login'),
      meta: { requiresAuth: false }

    },
    {
      path: '/',
      redirect: '/dashboard',
      component: () => import('@/layouts/Layout'),
      meta: { requiresAuth: true },
      children: [
        // Components
        {
          name: 'roadkills',
          path: '/roadkills',
          component: () => import('@/views/RoadKill/roadkills'),
        },
        {
          name: 'roadkillLocations',
          path: '/roadkillLocations',
          component: () => import('@/views/RoadKill/roadkillLocations'),
        },
       

        {
          name: 'Users',
          path: 'Users',
          component: () => import('@/views/Users/Users'),
        },
        {
          name: 'User',
          path: 'User/:id',
          component: () => import('@/views/Users/User'),
        },
        {
          name: 'Sellers',
          path: 'Sellers',
          component: () => import('@/views/Sellers/Sellers'),
        },
        {
          name: 'Seller Verification',
          path: 'sellerVerification',
          component: () => import('@/views/Sellers/sellerVerification'),
        },
        {
          name: 'Seller',
          path: 'Seller/:id',
          component: () => import('@/views/Sellers/Seller'),
        },
        {
          name: 'Purchases',
          path: 'Purchases',
          component: () => import('@/views/Purchases/purchases'),
        },
        {
          name: 'Purchase',
          path: 'Purchase/:id',
          component: () => import('@/views/Purchases/purchase'),
        },
        {
          path: 'category',
          component: {
            render(c) { return c('router-view') }
          },
          children: [
            {
              path: '',
              name: 'category',
              component: () => import('@/views/Category/Categories'),
            },
            {
              name: 'subcategory',
              path: ':id',
              props: true,
              component: () => import('@/views/Category/Category'),
            },
          ]
        },
        {
          name: 'Products',
          path: 'Products',
          component: () => import('@/views/Products/products'),
        },
        {
          name: 'productDetails',
          path: 'productDetails/:id',
          component: () => import('@/views/Products/productDetails'),
        },
        
        {
          path: 'addImage',
          component: {
            render(c) { return c('router-view') }
          },
          children: [
            {
              path: 'category',
              name: 'categoryImage',
              component: () => import('@/views/addImages/category'),
            },
            {
              name: 'subcategoryImage',
              path: 'category/:id',
              props: true,
              component: () => import('@/views/addImages/subcategory'),
            },
          ]
        },
        
        
        {
          name: 'Changepassword',
          path: 'Changepassword',
          component: () => import('@/views/Settings/changePassword'),
        },


        {
          name: 'Profile',
          path: 'pages/profile',
          component: () => import('@/views/pages/Profile'),
        },


        {
          name: 'Dashboard',
          path: 'dashboard',
          component: () => import('@/views/dashboard/BasicDashboard'),
        },

      ]
    },

  ],
})

router.beforeEach((to, from, next) => {
  if (localStorage.getItem('token')) {
    axios({
      method: "POST",
      url: "validate/token",
      headers: {
        "x-auth-token": localStorage.getItem("token")
      }
    })
      .then(response => {
        if (!response.data.status) {
          localStorage.removeItem("token");
          localStorage.removeItem("role");
          store.commit("logoutUser");
          next({
            name: 'Login'
          })
          return
        }
      })
  }
  if (to.matched.some(route => route.meta.requiresAuth) && !store.state.isLoggedIn) {
    next({
      name: 'Login'
    })
    return
  }
  if (to.path === '/Login' && store.state.isLoggedIn) {
    next({
      path: '/'
    })
    return
  }
  next()
})

export default router